import React from 'react';
import { APIProvider, Map, AdvancedMarker, Pin } from '@vis.gl/react-google-maps';

const MapaUbicacion = () => {
  // Coordenadas proporcionadas
  const position = { lat: 23.98426484636179, lng: -104.64843019117967 };
  const API_KEY = 'AIzaSyBG5Kwp0AkYPz8B_qxsrMSroJ8aR37wYfU'; // Reemplaza esto con tu llave real

  return (
    <div style={{ height: '400px', width: '100%' }}>
      <APIProvider apiKey={API_KEY}>
        <Map
          defaultCenter={position}
          defaultZoom={15}
          mapId={'DEMO_MAP_ID'} // Requerido para marcadores avanzados
        >
          {/* Marcador en el punto exacto */}
          <AdvancedMarker position={position}>
            <Pin background={'#FBBC04'} glyphColor={'#000'} borderColor={'#000'} />
          </AdvancedMarker>
        </Map>
      </APIProvider>
    </div>
  );
};

export default MapaUbicacion;